import { defineStore } from "pinia"
import { computed, ref } from "vue"

export type AlertMessage = {
	message: string,
	ok?: {
		label?: string,
		handler?: any,
	},
	cancel?: {
		label?: string,
		handler?: any,
	}
}

export const useAlertStore = defineStore("alert", () => {

	const messages = ref<AlertMessage[]>([])

	const currentMessage = computed(() => {
		return messages.value.length > 0 ? messages.value[0] : undefined
	})

	function addMessage(message: string | AlertMessage): void {
		if (typeof (message) == "string") {
			messages.value.push({ message, ok: { label: "OK" } })
		} else {
			messages.value.push(message);
		}
	}

	function popMessage() {
		messages.value.shift();
	}

	return { currentMessage, addMessage, popMessage }

})